/**
 * 　(c) 2018 TERAOKA SEIKO CO., LTD. / 株式会社 寺岡精工
 * 　CONFIDENTIAL / 社外秘
 * 　無断開示・無断複製禁止
 */
/** 
 * ページネーション定義用コンポーネント
 */
<template>
	<div class="div-area paging">
		<!-- 件数表示 (FROM-TO/TOTAL) -->
		<div class="left" v-if="r_is_show_fromto && r_all_item_count !== 0">
			<!-- ({{countFrom}}-{{countTo}}/{{r_all_item_count}}) {{dispOptionText(r_option_text)}} -->
			<span v-html="getDispPageText()"></span>
			<slot name="left_item">
			</slot>
		</div>
		<!-- ページネーション -->
		<div class="right" v-if="r_is_show_results" style="display: flex; align-items: center;">
			{{r_messages.displayed_results}}
			<c-selectitem 
				style="width: 75px;float: right;"
				:r_list="m_arrSelectDispCnt"
				@input="changeItem"
				v-model="m_selected">
			</c-selectitem>
		</div>
		<!-- １ページあたりの表示件数 -->
		<div class="center">
			<ul class="pagination" v-show="check_page">
				<li v-on:click="onBtnFirstPage" v-bind:class="{'click-disable': r_current_page <= 1}" ><a style="cursor: pointer;" >&laquo;</a></li>
				<li v-on:click="onBtnBeforePage" v-bind:class="{'click-disable': r_current_page <= 1}" ><a style="cursor: pointer;" >&lt;</a></li>
				<li v-for="page in arr_page " v-on:click="onBtnMovePage(page.page)" v-bind:class="{'active': page.page == r_current_page }" ><a style="cursor: pointer;">{{page.page}}</a></li>
				<li v-on:click="onBtnNextPage"  v-bind:class="{'click-disable': r_current_page >= max_page}"><a style="cursor: pointer;">&gt;</a></li>
				<li v-on:click="onBtnEndPage"  v-bind:class="{'click-disable': r_current_page >= max_page}"><a style="cursor: pointer;">&raquo;</a></li>
			</ul>
		</div>
	</div>
</template>
<script>
/**
	<c-ifsearchpaging 
		ref="v_paging" 
		:r_current_page='m_nCurrentPage'
		r_disp_item_count=5
		@event_change_page="onChangePage"
		>
	</c-ifsearchpaging>

	//! ページ変更イベント
	onChangePage: function(nPage){
	},
*/
	 export default {
		/* 
		 * props 引数
		 */
		props:{
			'r_messages':{},
			'r_current_page':Number,
			'r_disp_item_count':[Number,String],			//!< 1ページのアイテム表示件数
			'r_all_item_count':Number,			//!< 全アイテム件数
			'r_cnt_prefix':{					//!< 
				type:Number,
				default:0
			},
			'r_is_show_results':{				//!< 表示件数を表示するか
				type:Boolean,
				default:false
			},
			'r_is_show_fromto':{				//!< From・Toを表示するか
				type:Boolean,
				default:false
			},
			'r_select_disp_count':{},			//!< 
			'r_option_text': {
				type: String,
				default: '',
			},
			// ページ表示タイプ(1:通常)
			'r_disp_page_type': {
				type: Number,
				default: 1,
			},
		},
		/**
		 * @member
		 * @instance
		 * @prop {string} m_selected - リスト表示データ数
		 **/
		data: function (){
			return{
				m_selected: this.r_disp_item_count,
				m_arrSelectDispCnt: [{
					value: 20,
					label: '20'
					}, {
					value: 50,
					label: '50'
					}],
			}
		},
		mounted:function(){
			if(this.r_select_disp_count){
				this.m_arrSelectDispCnt = this.r_select_disp_count;
			}
		},
		computed: {
			/*
			 * 表示されている初めのカウント
			 */
			countFrom: function () {
				// var offset = this.r_cnt_prefix?Number(this.r_cnt_prefix):0;
				var offset = 0;
				var from =  0;

				if(this.r_all_item_count > 0){
					if( this.r_current_page>1 ){// 2ページ目以降
						from = (this.r_disp_item_count * (this.r_current_page - 1)) + 1 - offset;
					}else{// 1ページ目
						from = 1;
					}
				}

				return from;
			},
			/*
			 * 表示されている最後のカウント
			 */
			countTo: function () {
				var offset = this.r_cnt_prefix?Number(this.r_cnt_prefix):0;
				var to = this.r_all_item_count;
				to = to + offset;
				var all = this.r_all_item_count;
				all = all + offset;

				if (to > (this.r_disp_item_count * (this.r_current_page))) {
					to = (this.r_disp_item_count * (this.r_current_page));
				}

				if (to > all) {
					to = all;
				}

				return to;
			},
			/*
			 * 表示されている全体のカウント
			 */
			countAll: function () {
				var offset = this.r_cnt_prefix?Number(this.r_cnt_prefix):0;
				var all = this.r_all_item_count;
				all = all + offset;

				return all;
			},
			/**
			 * ページネーションに表示するページ
			 */
			arr_page: function(){
				var arrPage = [];
				
				if ( this.r_current_page < 3 || this.max_page < 5) {
					for ( var i = 1; i <= this.max_page && i <= 5; i++) {
						var page = i;
						arrPage.push({
							page: page
						});
						
					}
				} else if ( this.r_current_page > this.max_page - 2  ) {
					for ( var i = this.max_page - 4; i <= this.max_page; i++) {
						var page = i;
						arrPage.push({
							page: page
						});
					}
				} else {
					for ( var i = this.r_current_page - 2; i <= this.r_current_page + 2; i++) {
						var page = i;
						arrPage.push({
							page: page
						});
					}
				}
				return arrPage;
			},
			check_page: function(){
				if ( this.max_page > 0 ) {
					return true;
				}
				return false;
			},
			//! 最大ページ数
			max_page:function(){
				// var offset = this.r_cnt_prefix?Number(this.r_cnt_prefix):0;
				// return Math.ceil((this.r_all_item_count + offset)/this.r_disp_item_count);
				if (this.r_disp_page_type == 1) {
					var offset = this.r_cnt_prefix?Number(this.r_cnt_prefix):0;
					return Math.ceil((this.r_all_item_count + offset)/this.r_disp_item_count);
				} else if (this.r_disp_page_type == 2) {
					return 0;
				}
			},
		},
		methods: {
			onBtnFirstPage: function(){
				this.$emit("event_change_page",1);
			},
			onBtnBeforePage: function(){
				var beforePage = this.r_current_page-1; 
				if (beforePage <= 1) {
					beforePage = 1;
				}
				this.$emit("event_change_page",beforePage);
			},
			onBtnMovePage: function(page){
				this.$emit("event_change_page",page);
			},
			onBtnNextPage: function(){
				this.$emit("event_change_page",this.r_current_page+1);
			},
			onBtnEndPage: function(){
				this.$emit("event_change_page",this.max_page);
			},
			/**
			 * changeeventを取得したら、変更があるかチェックし表示データ数とページを初期化しページ更新フラグをTrueにする。
			 * @function m_selected
			 * @prop {number} val - 変更後データ
			 * @prop {number} oldVal - 変更前データ
			 * @instance
			 **/
			changeItem: function(value){
				var target = this;
				var ngCallback = function(){target.returnStateCount();}
				this.$emit("event_change_disp_count", value, ngCallback);
			},
			returnStateCount: function(){
				this.m_selected = this.r_disp_item_count;
			},
			// ページ表示
			getDispPageText: function() {
				var result = '';

				// ページ数 + テキスト
				if (this.r_disp_page_type == 1) {
					result += '(';
					result += this.countFrom;
					result += '-';
					result += this.countTo;
					result += '/';
					result += this.countAll;
					result += ')';

					if (this.r_option_text) {
						result += ' ';
						result += this.r_option_text;
					}
				// テキストのみ
				} else if (this.r_disp_page_type == 2) {
					if (this.r_option_text) {
						result += ' ';
						result += this.r_option_text;
					}
				}

				return result;
			},
			// // 外部取得時間表示
			// dispOptionText: function(val) {
			// 	// var result = (val) ? val : '';
			// 	var result = '';
			// 	if (val) {
			// 		// result += (this.r_messages.as_of) ? this.r_messages.as_of + ' ' : '';
			// 		result += val;
			// 	} else {
			// 		result = '';
			// 	}
			// 	return result;
			// },
		}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/viewPaging.vue